import type { AttributesAlertProps } from '#lib/components/Attributes.types.js';
import type { TIdentify, TPrioritize } from './columns';

// "Derived" in the qminor/qmajor source fields means the AADT was estimated, not measured.
export const getAccuracyWarnings = (attrs: TIdentify | TPrioritize): AttributesAlertProps[] =>
	[
		attrs.qminor_source === 'Derived' && {
			contentHtml: 'Controlled leg AADT data not available, AADT has been estimated.',
			variant: 'danger' as const
		},
		attrs.qmajor_source === 'Derived' && {
			contentHtml: 'Priority leg AADT data not available, AADT has been estimated.',
			variant: 'warning' as const
		}
	].filter((alert) => !!alert);
